import React from 'react';
import styled from 'styled-components';
import { SelectionTitle } from '../../../Styles';
import {
  ShippingFilterState
} from "@/components/customers/product/productBody/sidebar/QuickShipSwitch";

const Wrapper = styled.div`
  margin-top: 25px;
  padding: 0 25px;

  .sizes-container {
    margin-top: 10px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 15px;
  }
`;

const order = [
  'Twin',
  'Full',
  'Queen',
  'King',
  'California King',
  `16" x 16"`,
  `18" x 18"`,
  `20" x 20"`,
  `22" x 22"`,
  `26" x 26"`,
  `2' x 2'11"`,
  `2' x 3'`,
  `2' x 8'`,
  `2'2" x 7'8"`,
  `2'6" x 8'`,
  `2'7 x 10"`,
  `2'7" x 10'`,
  `2'7" x 7'10"`,
  `2'7" x 7'3"`,
  `3' x 5'`,
  `4' x 6'`,
  `5' x 7'6"`,
  `5' x 8'`,
  `5'1" x 7'`,
  `5'3 x 7'7`,
  `5'3" x 7'10"`,
  `5'3" x 7'3"`,
  `5'3" x 7'7"`,
  `5'11" x 8'10"`,
  `6' x 9'`,
  `6'4" x 9'`,
  `6'7" x 9'`,
  `6'7" x 9'6"`,
  `7'3" x 10'6"`,
  `7'6" x 10'6"`,
  `7'8" x 10'`,
  `7'10" x 10'`,
  `7'10 x 10'2"`,
  `7'10" x 10'10"`,
  `7'10" x 10'2"`,
  `7'10" x 10'3"`,
  `8' x 10'`,
  `8' x 10'6"`,
  `8' x 11'`,
  `9' x 12'`,
  `9' x 13'`,
  `9'10" x 13'1"`,
  `10' x 14'`
];

export const Sizes = {
  TWENTY_INCHES: '8'
}

function Size({
  sizeId,
  availableSizes,
  productData,
  setProductVar,
  setChangeFeaturedFabrics,
  shippingFilter
}) {
  const handleProductVar = sizeId => {
    setProductVar({
      frame_id: productData.frame.id,
      //render property / value if the size is not null
      size_id: sizeId,
      ...(productData.constructionType && {
        construction_type_id: productData.constructionType.id
      }),
      ...(productData.fabric && {
        fabric_id: productData.fabric.id
      }),
      ...(productData.frame.firmness && {
        firmness_id: productData.frame.firmness.id
      }),
      //render property / value if the leg is not null
      ...(productData.leg && {
        leg_id: productData.leg.id
      }),
      ...(productData.casterLeg && {
        caster_leg_id: productData.casterLeg.id
      }),
      ...(productData.frame.has_assembly_options && {
        is_assembled: productData.is_assembled
      }),
      ...(productData.frame.has_set_of_two && {
        supplier_quantity: productData.supplier_quantity
      }),
      ...(productData.frame.has_wallpaper_types && {
        wallpaper_type: productData.wallpaper_type
      })
    });
    setChangeFeaturedFabrics(true);
  };

  // Hardcode for sale; remove when we update the API
  if (shippingFilter === ShippingFilterState.QUICK_SHIP) {
    availableSizes = availableSizes.filter(({ id }) => id === Sizes.TWENTY_INCHES);
  }

  return (
    <Wrapper>
      <SelectionTitle>Select Size</SelectionTitle>
      <div className="sizes-container">
        {[...availableSizes]
          .sort((a, b) => order.indexOf(a.name) - order.indexOf(b.name))
          .map((sizeItem, i) => {
            return (
              <SizeButton
                key={`${sizeItem.id}-${sizeItem.is_available_on_pdp}`}
                disabled={!sizeItem.is_available_on_pdp}
                onClick={() => {
                  handleProductVar(sizeItem.id);
                }}
                index={i}
                selected={sizeId === sizeItem.id}
              >
                {sizeItem.name}
              </SizeButton>
            );
          })}
      </div>
    </Wrapper>
  );
}

export default Size;

const SizeButton = styled.button`
  border: ${({ selected, theme }) =>
    selected ? `3px solid ${(theme.old ? '#2A5CAF' : theme.colors.french)}` : '1px solid black;'};
  height: 50px;
  width: 100%;
  /* max-width: ${({ theme }) => theme.old ? 0 : '80px'}; */
  border-radius: 0;
  background: ${({ disabled }) =>
    disabled
      ? `linear-gradient(to top left,
             rgba(0,0,0,0) 0%,
             rgba(0,0,0,0) calc(50% - 0.8px),
             rgba(0,0,0,1) 50%,
             rgba(0,0,0,0) calc(50% + 0.8px),
             rgba(0,0,0,0) 100%)`
      : 'white'};

  background-color: ${({ disabled }) => (disabled ? '#f8f8f8' : 'transparent')};
  grid-column: ${({ index }) => (index === 4 ? 'span 2' : 'span 1')};

  cursor: ${({ disabled }) => (disabled ? 'initial' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? '0.8' : '1')};

  &:hover {
    outline: none;
  }
`;
